import { render, staticRenderFns } from "./ChartParetoReclamacaoSubestacaoTecnicos.vue?vue&type=template&id=281b7938&"
import script from "./ChartParetoReclamacaoSubestacaoTecnicos.vue?vue&type=script&lang=js&"
export * from "./ChartParetoReclamacaoSubestacaoTecnicos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard,VCardText,VCardTitle})
